import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from "./logo.png";
const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt
        glareEnable={true}
        glareMaxOpacity={0.25}
        scale={1.05}
        tiltMaxAngleX={10}
        tiltMaxAngleY={10}
      >
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          <div className="card-face card-front p-4">
            <h5 className="brand-title text-center  d-flex  justify-content-center align-items-center">
           
                <img src={logo} width="250" height="auto" alt="" />{" "}
            
            </h5>

            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div>
                  <h5 className="card-name mb-1">Mr. T P S Lamba</h5>
                  <p className="card-role mb-1">Partner</p>
                  <p className="card-phone mb-0">+91 98111-42962</p>
                </div>
              </div>
              <div className="qr-code-front">
                <QRCodeSVG
  value="https://lamba-1.highxbrandindia.in/"
  size={80}
  fgColor="#000000"
/>
              </div>
            </div>

            {/* <p className="address mt-4 small text-muted">
              <i className="fa fa-map-marker me-2"></i>
              Office No-306, 3rd Floor, RG Trade Tower, <br />
              Netaji Subhash Place, New Delhi - 110034
            </p> */}
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
             <h5 className="brand-title text-center  d-flex  justify-content-center align-items-center">
           
                <img src={logo} width="250" height="auto" alt="" />{" "}
            
            </h5>
            <div className="row">
              <div className="col-sm-12">
                <p className="address  small text-muted">
                  <div>
                    {" "}
                    <i className="fa fa-map-marker me-2"></i> Khasra No.57/11/1/2, 11/2/2, Village Dhaturi, Dist. Sonipat - 131001{" "}
                  </div>
                </p>
               
              </div>
              {/* <div className="col-sm-6">
                <p className="address  small text-muted">
                  <div>
                    {" "}
                    <i className="fa fa-map-marker me-2"></i> Factory :- PP-55
                    Gali no - 10 , Anand parvat , Industrial Area , Delhi
                    -5{" "}
                  </div>
                </p>
               
              </div> */}
              <div className="col-sm-12 pb-2">
                 <QRCodeSVG
                  value="https://maps.app.goo.gl/FVHrZ11aboLk45UD6"
                  size={60}
                  fgColor="#000000"
                />
              </div>
            </div>
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div
        className="d-flex flex-column gap-3 mt-5 w-75 mx-auto"
        style={{ maxWidth: "280px" }}
      >
        <a href="/T-P-S-Lamba.vcf" download className="platinum-btn">
          Add To Contacts
        </a>
        <a href="tel:+919811142962" className="platinum-btn">
          Call Now
        </a>
        <a href="mailto:bobblamb@hotmail.com" className="platinum-btn">
          Email Us
        </a>
        <a
          href="https://wa.me/+919811142962"
          target="_blank"
          className="platinum-btn"
        >
          WhatsApp
        </a>

        <a
          href="https://lamba-1.highxbrandindia.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Website
        </a>
        <a
          href="https://maps.app.goo.gl/FVHrZ11aboLk45UD6"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Address Details
        </a>
        
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
